import Resource from 'Resources/Resource';
import { STYLE, TYPE } from 'Store/reducers/SystemNotificationReducer';

class FormSubmitResource extends Resource {
	notifications: { [key: string]: () => { [key: string]: string } };

	constructor() {
		super('formSubmits');

		// Parity with the ResourceHelper config on upsales/common/resources/formSubmit.js. The save
		// bodies it also set are deliberately left off — EditFormSubmitModal already saves through
		// here without them. The delete toast is new for the other two delete call sites,
		// ListFormSubmits and EditFormSubmitModal, which is the same toast the Angular path gave.
		this.notifications = {
			delete: () => ({
				title: 'default.deleted',
				body: 'deleted.formSubmit',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.formSubmit',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			})
		};
	}
}

const resource = new FormSubmitResource();

export default resource;
